var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "pro_chiose_right"
  }, [_c('div', {
    staticClass: "head"
  }, [_c('div', [_vm._v($t("cg68d24", "已选择（") + _vm._s(_vm.value.length) + "）")]), _c('a', {
    staticClass: "text-[#2D5EF7]",
    on: {
      "click": _vm.onDeleteAll
    }
  }, [_vm._v($t("jdw52", "清空"))])]), _c('div', {
    staticClass: "content pt-[10px] pb-[10px]"
  }, _vm._l(_vm.value, function (item) {
    return _c('div', {
      key: item.id,
      staticClass: "list_checked_item",
      on: {
        "click": function ($event) {
          return _vm.onDelete(item);
        }
      }
    }, [item.userId ? _c('Icon', {
      staticClass: "text-[#2d8cf0]",
      attrs: {
        "size": 16,
        "type": "md-person"
      }
    }) : _vm._e(), item.orgId ? _c('Icon', {
      staticClass: "text-[#2d8cf0]",
      attrs: {
        "size": 16,
        "type": "md-folder"
      }
    }) : _vm._e(), item.tagId ? _c('Icon', {
      staticClass: "text-[#2d8cf0]",
      attrs: {
        "size": 16,
        "type": "md-pricetag"
      }
    }) : _vm._e(), item.appId ? _c('Icon', {
      staticClass: "text-[#2d8cf0]",
      attrs: {
        "size": 16,
        "type": "md-apps"
      }
    }) : _vm._e(), _c('div', {
      staticClass: "item_name"
    }, [_vm._v(_vm._s(item.name))]), _c('Icon', {
      staticClass: "text-[#bdbdbd]",
      attrs: {
        "size": 16,
        "type": "md-close-circle"
      }
    })], 1);
  }), 0)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };